import { layouts } from '@ocean/ui'
import { SectionSpaceSize } from '@ocean/ui/dist/layouts/SectionSpaceLayout/types'

const { SectionLayout, SectionSpaceLayout } = layouts

type ErrorWrapperLayoutProps = {
  verticalSpace?: SectionSpaceSize
}

const ErrorWrapperLayout: React.FC<ErrorWrapperLayoutProps> = ({ children, verticalSpace }) => {
  return (
    <SectionSpaceLayout size={verticalSpace}>
      <SectionLayout>{children}</SectionLayout>
    </SectionSpaceLayout>
  )
}

export default ErrorWrapperLayout
